export default "__VITE_ASSET__Cpcmdw8P__"